
import { defineComponent, onMounted, ref } from "vue";

import apis, { LoginModel } from "@/apis";
import UserStatus from "@/utils/userStatus";
import { AlertQueue, MessageTable } from "@/utils/alertQueue";

export default defineComponent({
  setup() {    
    const pageModel = ref({
      account: "",
      password: "",
    } as LoginModel);

    const hb = ref(null as string | null);

    const submitContent = async () => {
      try {
        if (hb.value === null)
          hb.value = (await apis.apiGetHeartbeat()).data["requestToken"];

        if (!hb.value) {
          AlertQueue.danger(MessageTable.generalError);
          return;
        }

        const d = (await apis.apiPostLogin(hb.value, pageModel.value)).data;
        if (d && d.status > 200) {
          AlertQueue.warn(MessageTable.loginFailure);
          return;
        }

        AlertQueue.info(MessageTable.loginSuccessful);
        apis.resetLoginModel(pageModel.value);
        UserStatus.updateUserStatus(true);
        hb.value = (await apis.apiGetHeartbeat()).data["requestToken"];
      } catch (e) {
        AlertQueue.danger(e);
      }
    };

    const submitLogout = async () => {
      try {
        if (hb.value === null)
          hb.value = (await apis.apiGetHeartbeat()).data["requestToken"];

        if (!hb.value) {
          AlertQueue.danger(MessageTable.generalError);
          return;
        }

        const d = (await apis.apiPostLogout(hb.value)).data;
        if (d && d.status > 200) {
          AlertQueue.warn(MessageTable.generalError);
          return;
        }

        AlertQueue.info(MessageTable.logoutSuccessful);
        UserStatus.updateUserStatus(true);
        hb.value = (await apis.apiGetHeartbeat()).data["requestToken"];
      } catch (e) {
        AlertQueue.danger(e);
      }
    }

    onMounted(async () => {
      UserStatus.updateUserStatus();
    });

    return {
      userStatus: UserStatus.status,
      pageModel,
      submitContent,
      submitLogout,
    };
  },
  components: {
  },
});
